import { parse } from "cookie";

export const deleteImpersonatedUser = (cookies) => {
  if ("qpp_impersonated_user" in cookies) {
    document.cookie =
      "qpp_impersonated_user=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  if ("qpp_impersonated_type" in cookies) {
    document.cookie =
      "qpp_impersonated_type=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
};

export const revertApmPaymentCookie = () => {
  const userHasApmPayments = localStorage.getItem("user_has_apm_payments");

  if (userHasApmPayments) {
    document.cookie = `user_has_apm_payments=${userHasApmPayments}; Path=/;`;
  }
};

export const revertQppHasAuthsCookie = () => {
  const { qppHasAuthorizations, behindSSL } = JSON.parse(
    localStorage.getItem("impersonatorAuthValues"),
  );
  if (qppHasAuthorizations) {
    document.cookie = `qpp_has_authorizations=${qppHasAuthorizations};path=/${
      behindSSL ? ";secure" : ""
    }`;
  }
};

/**
 * Makes an API request to end the user session.
 * @param  {Object} [_window] The DOM Window
 * @return {Function} Returns a promise
 */
const LogoutSession = async (_window) => {
  // Remove the Side Nav expanded state from localStorage
  localStorage.removeItem("qpp_side_nav_expanded");

  let cookies = parse(_window.document.cookie);
  let logoutDestination = "/logout-confirmation";

  if ("qpp_auth_token" in cookies) {
    let onSuccess = () => {
      // redirect to login/logged out screen
      deleteImpersonatedUser(cookies);
      _window.location.pathname = logoutDestination;
    };

    let onError = () => {
      // delete cookie and redirect login/logged out screen
      deleteImpersonatedUser(cookies);
      _window.location.pathname = logoutDestination;
    };

    try {
      const url = "/user/session-logout";
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies.qpp_auth_token}`,
        },
      };
      await fetch(url, options);
      onSuccess();
    } catch (error) {
      onError();
      console.log(error);
    }
  } else {
    _window.location.pathname = logoutDestination;
  }
};

export default LogoutSession;
